/* eslint-disable prefer-template */
/* eslint-disable no-use-before-define */
/* eslint-disable vars-on-top */
/* eslint-disable one-var */
/* eslint-disable prefer-destructuring */
/* eslint-disable func-names */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-var */
module.exports = function () {

    var parameterize = function (urlTemplate, parameters) {
        var url = urlTemplate;

        if (url && parameters) {
            url = url.replace(/\{\{\s*(.*?)\s*\}\}/g, function (match, group) {
                if (parameters.hasOwnProperty(group)) {
                    return parameters[group];
                }
                return match;
            });
        }

        return url;
    };

    var unescapeBaseUrl = function (url) {
        var result = url || '';

        // eslint-disable-next-line no-extra-boolean-cast
        if (!!url) {
            // eslint-disable-next-line no-useless-escape
            var baseUrlProbe = url.match(/(https?:)?\/\/[^\/]*/i);
            if (!!baseUrlProbe && baseUrlProbe.length) {
                result = url.replace(baseUrlProbe[0], decodeURIComponent(baseUrlProbe[0]));
            }
        }

        return result;
    };

    var launchReport = function (event, currentReportSecurityType) {
        var securityId = event.detail.shareclassId;
        var securityType = event.detail.securityType;
        var reg1 = /(^|&|\/?)shareClassId=([^&#]*)/i;
        var reg2 = /(^|&|\/?)securityType=([^&#]*)/i;
        var tempUrl, fundUrl;

        if (reg1.test(window.location.href)) {
            tempUrl = window.location.href.replace(`shareClassId=${RegExp.$2}`, `shareClassId=${securityId}`);
        }

        const userType = window.location.hash.split("?")[0].split("-")[1];
        var reg3 = getBaseURLBySecurityType(currentReportSecurityType, userType);

        if (reg2.test(tempUrl)) {
            fundUrl = tempUrl.replace(`securityType=${RegExp.$2}`, `securityType=${securityType}`);
        } else {
            fundUrl = tempUrl + '&securityType=' + securityType;
        }

        const baseUrlMapData = getBaseURLBySecurityType(securityType, userType);
        fundUrl = fundUrl.replace(reg3.endPoint, baseUrlMapData.endPoint);
        fundUrl = fundUrl.replace(reg3.comId, baseUrlMapData.comId);
        window.open(fundUrl);
    };

    var singleAppLaunchReport = function (event) {
        const { shareclassId, securityType, userType } = event.detail;

        const url = new URL(location.href);
        const authPosition = url.hash.indexOf("authType")+9;
        const authType = `${url.hash.substring(authPosition)}`;
        var targetData = getBaseURLBySecurityType(securityType, userType);
        var contextPath = "/sal-components/index.html#";
        var urlTemplateParams = `${targetData.comId}?shareClassId=${shareclassId}&securityType=${securityType}&fundServCode=&authType=${authType}`;
        var urlTemplateComponent = `${contextPath}${targetData.endPoint}${urlTemplateParams}`;
        window.open(urlTemplateComponent);
    };

    var getBaseURLBySecurityType = function (securityType, userType) {
        const baseURLMap = {
            "ST": {
                endPoint: `/app`,
                comId: `/eqsv-${userType}`,
            },
            "FO": {
                endPoint: `/mip`,
                comId: `/mip-${userType}`,
            },
            "FE": {
                endPoint: `/mip`,
                comId: `/mip-${userType}`
            },
            "FV": {
                endPoint: `/mip`,
                comId: `/mip-${userType}`
            },
            "V1": {
                endPoint: `/mip`,
                comId: `/mip-${userType}`
            },
            "FC": {
                endPoint: `/cef`,
                comId: `/cef-${userType}`,
            },
            "CZ": {
                endPoint: `/cit`,
                comId: `/cit-${userType}`,
            },
            "SA": {
                endPoint: `/sma`,
                comId: `/sma-${userType}`,
            },
            "VA": {
                endPoint: `/subacc`,
                comId: `/subacc-${userType}`,
            },
            "VL": {
                endPoint: `/subacc`,
                comId: `/subacc-${userType}`,
            },
            "CT": {
                endPoint: `/educt`,
                comId: `/educt-${userType}`,
            },
            "CP": {
                endPoint: `/educp`,
                comId: `/educp-${userType}`,
            },
            "MO": {
                endPoint: `/models`,
                comId: `/models-${userType}`,
            },
            "XI": {
                endPoint: `/index`,
                comId: `/index-${userType}`,
            },
            "FM": {
                endPoint: `/moneymarket`,
                comId: `/moneymarket-${userType}`,
            }
        };

        return baseURLMap[securityType];
    }

    return {
        parameterize,
        unescapeBaseUrl,
        launchReport,
        singleAppLaunchReport
    };
}();